import { createElement, Fragment, type ReactNode } from 'react'
import type { FollowUpKind } from '../../../types/followUp'

// CF-1 contract (P2/P4/P5 consume verbatim): the only extension point for a Follow-up section's
// action UI. Built-in kinds key by FollowUpKind; a custom kind keys by `custom:${customKindId}`.
export type SectionSlotKey = FollowUpKind | `custom:${string}`
export type SectionSlots = Partial<Record<SectionSlotKey, ReactNode>>

export function sectionSlotKey(kind: FollowUpKind, customKindId?: string | null): SectionSlotKey {
  return kind === 'Custom' && customKindId ? `custom:${customKindId}` : kind
}

/** Concatenates the nodes for the same key in argument order (each later plan builds its own slots
 *  and the page merges them). */
export function mergeSectionSlots(...parts: SectionSlots[]): SectionSlots {
  const collected: Partial<Record<SectionSlotKey, ReactNode[]>> = {}
  for (const part of parts) {
    for (const [key, node] of Object.entries(part) as [SectionSlotKey, ReactNode][]) {
      if (node === undefined || node === null || node === false) continue
      ;(collected[key] ??= []).push(node)
    }
  }
  const merged: SectionSlots = {}
  for (const [key, nodes] of Object.entries(collected) as [SectionSlotKey, ReactNode[]][]) {
    merged[key] = nodes.length === 1
      ? nodes[0]
      : nodes.map((n, i) => createElement(Fragment, { key: i }, n))
  }
  return merged
}
